import styled from 'styled-components'

import { ButtonIcon } from '../buttonIcon'

export const FloatingIcon = styled(ButtonIcon)`
  z-index: 100;
  position: fixed;
  bottom: 0;
  right: 0;

  transition: transform ease-in 0.2s;

  margin: 25px;

  width: 6vw;
  height: 6vw;

  @media (max-width: 700px) {
    width: 10vw;
    height: 10vw;
  }

  &:hover {
    transform: scale(105%);
  }
`
